var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.115 2.46c.829-.044 1.495.337 2.024.907.502.542.835 1.21.995 1.683V16.876h5.815l.127-.05a19.502 19.502 0 0 0 1.858-.845c.342-.178.686-.375.988-.578.293-.198.588-.427.799-.68a8.82 8.82 0 0 0 .39-.51c.032.02.066.041.103.066.806.537 4.315 3.244 4.045 8.237-.13 2.419-1.465 4.17-3.007 5.339a9.895 9.895 0 0 1-2.288 1.293c-.725.288-1.282.397-1.55.397H6.463V5.009c.09-.413.328-1.03.754-1.555.436-.535 1.046-.95 1.905-.995zM22.73 12.882c.1.058.198.122.293.185.941.627 5.003 3.745 4.69 9.527-.16 2.97-1.81 5.077-3.58 6.42a11.35 11.35 0 0 1-2.631 1.486c-.8.318-1.554.5-2.087.5H5.005V4.867l.013-.067A5.337 5.337 0 0 1 6.08 2.536c.638-.782 1.605-1.46 2.959-1.53a3.77 3.77 0 0 1 2.38.685c2.524-.038 6.177.052 7.704.625 2.33.874 4.368 2.62 4.368 7.717a5.5 5.5 0 0 1-.762 2.85z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBico);
export default __webpack_public_path__ + "static/media/BICO.477ebac0f8260ae3e05c74f935da5681.svg";
export { ForwardRef as ReactComponent };